import banner from "../../../courses/module-1/img3.png";

const modulo3_pt = {
  courseId: "finanzas-personales",
  id: "modulo-3", // ⚠️ Mesmo ID
  title: "📘 MÓDULO 3: Poupança com Propósito",
  estimatedDuration: "2 horas",
  format: "Leitura + exercícios + tarefa prática",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos do módulo",
      content: [
        "Entender por que poupar “por poupar” não costuma funcionar.",
        "Identificar tipos de poupança que fazem sentido para sua realidade como estudante.",
        "Criar um plano de poupança personalizado com metas claras, alcançáveis e motivadoras.",
      ],
    },
    {
      id: "lectura",
      navLabel: "Leitura principal",
      title: "📖 Leitura principal: Poupar só por poupar? Nem sempre funciona",
      content: [
        {
          type: "paragraph",
          text: "📌 Por que poupar “porque sim” não basta?",
        },
        {
          type: "paragraph",
          text: "Muitas vezes ouvimos “você precisa poupar”, mas ninguém explica para quê ou como.",
        },
        {
          type: "paragraph",
          text: "O problema de poupar sem um propósito claro é que:",
        },
        {
          type: "list",
          items: [
            "Fica fácil quebrar a poupança por impulso.",
            "Falta motivação para continuar.",
            "Você sente que está guardando “por nada” e desiste rápido.",
          ],
        },
        {
          type: "paragraph",
          text: "O verdadeiro combustível da poupança é ter uma meta concreta, pessoal e emocionalmente significativa.",
        },
      ],
    },
    {
      id: "proposito",
      navLabel: "Propósito",
      title: "🎯 O que é poupar com propósito?",
      content: [
        {
          type: "paragraph",
          text: "É guardar dinheiro com um objetivo claro, algo que te motive de verdade. Pode ser:",
        },
        {
          type: "list",
          items: [
            "Algo que te anima — viagem, show, um gadget.",
            "Algo que dá segurança — fundo de emergência.",
            "Algo que te leva ao futuro — cursos, mudança, independência.",
          ],
        },
      ],
    },
    {
      id: "tipos",
      navLabel: "Tipos de poupança",
      title: "🧩 Tipos de poupança",
      content: [
        {
          type: "table",
          headers: ["Tipo", "Para que serve?", "Exemplo real"],
          rows: [
            [
              "Fundo de emergência",
              "Para imprevistos: doença, acidentes, emergências",
              "Ter R$ 200 guardados “para o que vier”",
            ],
            [
              "Poupança para metas",
              "Para objetivos específicos, com valor e prazo definidos",
              "Tirar passaporte, comprar notebook, participar de um retiro",
            ],
            [
              "Poupança de longo prazo",
              "Para projetos maiores ou independência",
              "Se mudar, empreender, pós-graduação",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "Regra básica recomendada: Antes de investir, construa um fundo de emergência equivalente a 1–3 meses dos seus gastos essenciais.",
        },
      ],
    },
    {
      id: "exemplo-real",
      navLabel: "Exemplo real",
      title: "💬 Exemplo real — jovem brasileiro",
      content: [
        {
          type: "paragraph",
          text: "🎓 Damião, 22 anos, freelancer pernambucano de design gráfico.",
        },
        {
          type: "paragraph",
          text: "Sonhava em ir a um festival de música com uma amiga.",
        },
        {
          type: "paragraph",
          text: "Descobriu que precisava de R$ 350 (ingresso + transporte + comida).",
        },
        {
          type: "paragraph",
          text: "Criou uma meta SMART: poupar R$ 25 por semana durante 4 meses.",
        },
        {
          type: "paragraph",
          text: "Ele conseguiu usando um cofrinho e colocando uma foto do festival na parede para visualizar seu objetivo.",
        },
      ],
    },
    {
      id: "estrategias",
      navLabel: "Estratégias",
      title: "🛠 Estratégias de poupança para estudantes",
      content: [
        {
          type: "list",
          items: [
            "Método dos 10%: guarde 10% de todo dinheiro que receber.",
            "Poupança visual: coloque uma foto da sua meta em um lugar visível.",
            "Sistema de envelopes (físicos ou digitais): divida seu dinheiro por categorias.",
            "Arredondamento inteligente: gastou R$ 19? Arredonde para R$ 20 e poupe o R$ 1 restante.",
            "Apps úteis: Mobills, MinhasEconomias, Money Manager.",
            "Poupança em grupo: faça uma vaquinha recorrente com amigos de confiança.",
          ],
        },
      ],
    },
    {
      id: "meta-smart",
      navLabel: "Meta SMART",
      title: "🧠 Como definir uma meta de poupança SMART?",
      content: [
        {
          type: "paragraph",
          text: "Uma meta SMART é:",
        },
        {
          type: "list",
          items: [
            "S – Específica: o que exatamente quero alcançar?",
            "M – Mensurável: quanto custa?",
            "A – Atingível: é realista para minha renda?",
            "R – Relevante: por que isso importa para mim?",
            "T – Temporal: em quanto tempo vou alcançar?",
          ],
        },
        {
          type: "paragraph",
          text: "📌 Exemplo:",
        },
        {
          type: "paragraph",
          text: "“Quero poupar R$ 150 para comprar um celular em 3 meses, guardando R$ 12,50 por semana.”",
        },
      ],
    },
    {
      id: "tabla-smart",
      navLabel: "Tabela SMART",
      title: "📋 Tabela interativa de metas SMART",
      content: [
        {
          type: "link",
          href: "https://docs.google.com/spreadsheets/d/1Dxejb_qtBMcCADWzIDMf7K-s0r0Oplr14FMMzXyHzss/edit?gid=0",
          text: "🔗 Acesse aqui a tabela de metas SMART",
        },
        {
          type: "paragraph",
          text: "Como usar:",
        },
        {
          type: "list",
          items: [
            "Faça uma cópia no seu Google Drive (Arquivo > Fazer uma cópia).",
            "Preencha com sua meta pessoal.",
          ],
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Atividade",
      title: "🧠 Exercício de reflexão",
      content: [
        "1. Pense em algo que deseja e responda:",
        {
          type: "list",
          items: [
            "O que quero?",
            "Quanto custa?",
            "Quando preciso disso?",
            "Quanto posso guardar por semana ou mês?",
            "Que gasto posso reduzir para alcançar essa meta?",
          ],
        },
        "2. Escreva sua meta SMART completa.",
        "3. Preencha a tabela com essas informações.",
      ],
    },
    {
      id: "lectura-complementaria",
      navLabel: "Leitura complementar",
      title: "📚 Leitura complementar",
      content: [
        {
          type: "link",
          href: "https://brasil.elpais.com/brasil/2016/06/16/economia/1466090161_043065.html ",
          text: "“Seu pai sabe menos de finanças que você” – El País",
        },
      ],
    },
    {
      id: "bibliografia-recomendada",
      navLabel: "Bibliografia recomendada",
      title: "📚 Bibliografia recomendada",
      content: [
        {
          type: "paragraph",
          text: "1. Sofía Macías – “Pequeno Porco Capitalista: Investimentos”",
        },
        {
          type: "paragraph",
          text: "2. CONDUSEF – “Poupança para jovens”",
        },
        {
          type: "paragraph",
          text: "3. Ramsey Solutions – “Saving with Purpose”",
        },
      ],
    },
    {
      id: "piramide",
      navLabel: "Pirâmide de investimento",
      title: "🔺 Extra: O que é a pirâmide de investimentos?",
      content: [
        {
          type: "paragraph",
          text: "Embora investimentos sejam tema de outro módulo, vale entender a ideia da pirâmide de investimentos, que mostra como distribuir seu dinheiro conforme o risco.",
        },
        {
          type: "paragraph",
          text: "🧱 Níveis da pirâmide",
        },
        {
          type: "table",
          headers: [
            "Nível",
            "Tipo de investimento",
            "Características",
            "Exemplos comuns",
          ],
          rows: [
            [
              "Base",
              "Segurança e liquidez",
              "Baixo risco, dinheiro fácil de resgatar",
              "Poupança, Tesouro Selic",
            ],
            [
              "Crescimento moderado",
              "Risco médio",
              "Retorno maior, prazo mais longo",
              "Fundos, CDBs",
            ],
            [
              "Alto rendimento",
              "Alto risco",
              "Pode dar lucro alto (ou prejuízo)",
              "Ações, criptomoedas, startups",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "Regra de ouro: só invista no topo depois de ter a base bem construída.",
        },
      ],
    },
    // {
    //   id: "evaluacion",
    //   navLabel: "Avaliação rápida",
    //   title: "📝 Avaliação rápida",
    //   content: [
    //     "Tarefa: criar seu plano de poupança com meta SMART",
    //     "📌 O que deve conter?",
    //     {
    //       type: "list",
    //       items: [
    //         "Sua meta específica e motivadora",
    //         "Valor total a ser poupado",
    //         "Tempo estimado",
    //         "Plano semanal ou mensal para alcançá-la",
    //         "Método de poupança (cofrinho, app, banco, vaquinha...)",
    //       ],
    //     },
    //   ],
    // },
    {
      id: "importancia",
      navLabel: "Importancia",
      title: "🎯 Por que isso importa num módulo de poupança?",
      content: [
        "Porque poupar e investir se complementam, mas são coisas diferentes:",
        {
          type: "list",
          items: [
            "Poupar = guardar para objetivos próximos.",
            "Investir = fazer seu dinheiro crescer para objetivos de médio e longo prazo.",
          ],
        },
        {
          type: "paragraph",
          text: "📌 Frase-chave:",
        },
        {
          type: "paragraph",
          text: "“Primeiro construa o colchão. Depois, as asas.”",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Frase do dia",
      title: "🧠 Frase do dia",
      content: [
        "“Poupar não é guardar o que sobra, mas escolher guardar o que te aproxima dos seus sonhos.”",
      ],
    },
  ],
};

export default modulo3_pt;
